export default __webpack_public_path__ + "static/media/mobile_fading_engagement.61342975.svg";